<template>
  <section class="zhi-neng-jian-bao">
    <PageBlock title="智能简报">
      <div class="content">
<!--        <p class="month">{{retailScaleVo.month}}2025年11月</p>-->
        <el-select class="month" v-model="selectMonth" size="mini" @change="monthChange">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <div style="display: flex;flex: 1;flex-direction: column;gap: 12px">
          <div style="display: flex" class="item" v-for="(item, index) in reportList" :key="index">
            <div class="left">{{ item.title }}</div>
            <div class="right">{{item.content}}</div>
          </div>
        </div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
// 引入 ECharts
export default {
  name: 'zhi-neng-jian-bao',
  components: {
    PageBlock
  },
  props: {
    smartReportVoList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    smartReportVoList: {
      handler(val) {
        console.log('smartReportVoList-----------');
        this.options = val.map(item => {
          this.reportMap[item.yearMonthStr] = item.smartReportList
          return {label: item.yearMonthStr, value: item.yearMonthStr}
        })
        if (!this.selectMonth) {
          this.selectMonth = this.options[this.options.length - 1].value
          this.reportList = this.reportMap[this.selectMonth]
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      options: [],
      selectMonth: '',
      reportMap: {},
      reportList: []
    };
  },
  mounted() {
  },
  methods: {
    monthChange (val) {
      console.log(val, this.reportMap, this.reportMap[val])
      this.selectMonth = val
      this.reportList = this.reportMap[val]
    }
  },
};
</script>

<style scoped lang="scss">
.zhi-neng-jian-bao {
  .content{
    padding: 11px;
    border-radius: 12px;
    background: rgba(102, 255, 255, 0.17);
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    .month{
      position: absolute;
      top: -52px;
      right: 0;
      color: #FFFFFF;
      margin: 0;
      width: 90px;
      background: transparent;
      ::v-deep input{
        background-color: transparent;
        border: none;
        color: #FFFFFF;
        font-size: 12px;
      }
    }
    .item{
      display: flex;
      .left{
        padding-right: 12px;
        height: 14px;
        font-size: 12px;
        color: #FFFFFF;
      }
      .right{
        flex: 1;
        line-height: 14px;
        font-size: 10px;
        font-weight: 350;
        color: #FFFFFF;

      }
    }
  }
}
</style>
